import { LibraryDatasetTable } from '@/components'
import { config } from '@/config'
import { DatasetSimple } from '@/interfaces'

import { useIncomeAdjustments } from '../hooks'

interface Props {
  datasets: DatasetSimple[]
}

export const IncomeAdjustmentDatasetsTable = ({ datasets }: Props) => {
  const { cloneDataset, isCloneDatasetInProgress, removeDataset } =
    useIncomeAdjustments()

  const allDatasetNames = datasets.map(x => x.name || '')

  const handleCloneDataset = (
    datasetId: number,
    datasetName: string,
    onSuccess: () => void
  ) => {
    cloneDataset({ datasetId, name: datasetName }, { onSuccess })
  }

  return (
    <LibraryDatasetTable
      datasets={datasets}
      getDetailsLink={datasetId =>
        `${config.links.library.incomeAdjustment}/${datasetId}`
      }
      isCloneInProgress={isCloneDatasetInProgress}
      onRemoveClicked={datasetId => removeDataset(datasetId)}
      onCloneClicked={handleCloneDataset}
      allDatasetNames={allDatasetNames}
    />
  )
}
